var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat" }, [
    _c("div", { staticClass: "chat-panel" }, [
      _c(
        "ul",
        {
          directives: [
            {
              name: "chat-scroll",
              rawName: "v-chat-scroll",
              value: { always: false },
              expression: "{ always: false }",
            },
          ],
          staticClass: "chat-messages",
          class: { "nice-scroll": !_vm.is_mobile },
        },
        _vm._l(_vm.asta_messages, function (item, index) {
          return _c(
            "li",
            { key: index, class: { "my-chat": item.id == _vm.user_uid } },
            [
              _vm.squadra(item.id)
                ? _c("div", [
                    _c(
                      "span",
                      {
                        staticClass: "chat-user",
                        style: { color: _vm.userColor(item.id) },
                      },
                      [_vm._v(_vm._s(_vm.squadra(item.id).name))]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "chat-msg",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.emoji(
                            item.text,
                            "unicodeToImage"
                          )
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }